(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  function injectBingeAccountStyles(accountEl) {
    if (!accountEl || !accountEl.shadowRoot) return;

    if (!accountEl.shadowRoot.getElementById('bc-account-vintage-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'bc-account-vintage-style';
      styleEl.textContent = `
        .dialog {
          background-color: #FAF6EF !important;
          color: #161513 !important;
          border: 3px solid #161513 !important;
          border-radius: 16px !important;
          box-shadow: 6px 6px 0px #161513 !important;
        }
        .account__header {
          background: #FAF6EF !important;
          border-bottom: 2px dashed #D4CFC4 !important;
          padding: 18px 20px 14px 20px !important;
          margin-bottom: 14px !important;
        }
        .account__header-content::before {
          content: "🎟️ CLUB MEMBER PASS";
          display: inline-flex;
          align-items: center;
          align-self: flex-start;
          padding: 2px 8px;
          border-radius: 4px;
          background-color: #E99D32;
          color: #161513;
          border: 1.5px solid #161513;
          box-shadow: 1.5px 1.5px 0px #161513;
          font-family: 'Space Grotesk', monospace;
          font-size: 10px;
          font-weight: 800;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 4px;
        }
        .account__heading {
          font-family: 'DM Serif Display', Georgia, serif !important;
          font-size: 24px !important;
          line-height: 1.15 !important;
          color: #161513 !important;
          font-weight: 400 !important;
        }
        .account__close,
        .account__back-button {
          width: 32px !important;
          height: 32px !important;
          border-radius: 8px !important;
          border: 2px solid #161513 !important;
          background-color: #FFFDF9 !important;
          color: #161513 !important;
          box-shadow: 2px 2px 0px #161513 !important;
          filter: none !important;
          transition: all 0.15s ease !important;
        }
        .account__close:hover,
        .account__back-button:hover {
          background-color: #E99D32 !important;
          transform: translate(-1px, -1px);
          box-shadow: 3px 3px 0px #161513 !important;
        }
        .stack-inline {
          padding-top: 14px !important;
          border-top: 2px dashed #D4CFC4 !important;
          gap: 10px !important;
        }
        .stack-inline .button.outline,
        .account__shortcuts {
          background-color: #FFFDF9 !important;
          color: #161513 !important;
          border: 2px solid #161513 !important;
          border-radius: 10px !important;
          box-shadow: 2px 2px 0px #161513 !important;
          font-family: 'Space Grotesk', monospace !important;
          font-size: 12px !important;
          font-weight: 800 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          filter: none !important;
          transition: all 0.15s ease !important;
        }
        .stack-inline .button.outline:hover {
          background-color: #E99D32 !important;
          transform: translate(-1px, -1px);
          box-shadow: 3px 3px 0px #161513 !important;
        }
      `;
      accountEl.shadowRoot.appendChild(styleEl);
    }

    const loaderEl = accountEl.shadowRoot.querySelector('shopify-login-form-loader');
    const loginFormEl = loaderEl && loaderEl.querySelector('shopify-login-form');
    if (loginFormEl && loginFormEl.shadowRoot && !loginFormEl.shadowRoot.getElementById('bc-login-vintage-style')) {
      const loginStyle = document.createElement('style');
      loginStyle.id = 'bc-login-vintage-style';
      loginStyle.textContent = `
        :host {
          background-color: #FAF6EF !important;
        }
        .button.shop-login,
        .login-form__social-login-button {
          border: 2px solid #161513 !important;
          border-radius: 10px !important;
          box-shadow: 2px 2px 0px #161513 !important;
          filter: none !important;
        }
        .login-form__divider-line {
          background-color: #D4CFC4 !important;
          height: 1.5px !important;
        }
        .login-form__divider-text {
          font-family: 'Space Grotesk', monospace !important;
          font-size: 11px !important;
          font-weight: 700 !important;
          letter-spacing: 0.08em !important;
          color: #6B665E !important;
        }
        .login-form__email-input {
          background-color: #FFFDF9 !important;
          border: 2px solid #161513 !important;
          border-radius: 10px !important;
          box-shadow: 2px 2px 0px #161513 !important;
          color: #161513 !important;
          filter: none !important;
        }
        .login-form__email-input:focus-visible {
          border-color: #161513 !important;
          box-shadow: 0 0 0 2px #E99D32, 2px 2px 0px #161513 !important;
        }
        .login-form__email-submit {
          background-color: #E99D32 !important;
          color: #161513 !important;
          border: 2px solid #161513 !important;
          border-radius: 8px !important;
          opacity: 1 !important;
        }
        .login-form__marketing-consent-visual {
          background-color: #FFFDF9 !important;
          box-shadow: 0 0 0 2px #161513 inset !important;
          border-radius: 4px !important;
        }
        .login-form__marketing-consent-checkbox:checked + .login-form__marketing-consent-visual {
          box-shadow: 0 0 0 10px #E99D32 inset, 0 0 0 2px #161513 !important;
        }
        .login-form__marketing-consent-label {
          color: #4A4742 !important;
          font-weight: 500 !important;
        }
      `;
      loginFormEl.shadowRoot.appendChild(loginStyle);
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
      injectBingeAccountStyles(event.target);
      setTimeout(() => injectBingeAccountStyles(event.target), 60);
      setTimeout(() => injectBingeAccountStyles(event.target), 250);
    },
    true
  );

  document.addEventListener('shopify-render', () => {
    document.querySelectorAll('shopify-account').forEach((el) => injectBingeAccountStyles(el));
  });

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
